module.exports = __webpack_public_path__ + "img/pointer.e8c27272.png";